export const Felho = Object.freeze({
  /** 17 */
  Jogosultsag: 17,
  /** 18 */
  FelhasznaloiCimkek: 18
});
